import { useCallback, useState } from "react";

export const useToggle = (initial?: boolean): [boolean, VoidFunction] => {
  const [state, setState] = useState(initial);
  const toggle = useCallback(() => setState(currentState => !currentState), []);

  return [state, toggle];
};
